import { EXTENSIONS } from 'probonio-shared-ui/registry';
import { ExtensionBuilder } from 'probonio-shared-ui/registry/extension-definition';
import { BenefitListItemExtensionInterface } from '../../../extension/interface/benefit-list-item.extension.interface';
import { BenefitMetadataExtensionInterface } from '../../../extension/interface/benefit-metadata.extension.interface';
import { RecreationBenefitListItemExtension } from './recreation-benefit-list-item.extension';
import { RecreationBenefitMetadataExtension } from './recreation-benefit-metadata.extension';

EXTENSIONS.registerExtension(
  new ExtensionBuilder('recreation')
    .add(BenefitMetadataExtensionInterface, new RecreationBenefitMetadataExtension())
    .add(BenefitListItemExtensionInterface, new RecreationBenefitListItemExtension())
    .build(),
);
